import { render, staticRenderFns } from "./softwareTableSimulation2.vue?vue&type=template&id=cc4bc722&"
import script from "./softwareTableSimulation2.vue?vue&type=script&lang=js&"
export * from "./softwareTableSimulation2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports